export const DisplayTypesInReportsConstant = {
    LIST: 1,
    FILTER: 2,
    TABS:3,
    REQ_LIST:4,
    REQ_FILTER:5,
    RES_COM_LIST:5,
    RES_COM_FILTER:5,
}
